import { mapLadderPercentageTypeToPicksInfo } from "../../../constants";
const getBoostData = (percentageLadder, boostSelections, originalBoostSelections) => {
    let originalBoostType;
    let matchedBoost;
    percentageLadder.forEach(percentageStep => {
        if (mapLadderPercentageTypeToPicksInfo[percentageStep.type] === originalBoostSelections) {
            originalBoostType = originalBoostType || percentageStep;
        }
        if (mapLadderPercentageTypeToPicksInfo[percentageStep.type] === boostSelections && !matchedBoost) {
            matchedBoost = percentageStep;
        }
    });
    return {
        originalBoostType,
        matchedBoost,
    };
};
export function mapBoostHeaderInfo(dictionary, percentageLadder, boostSelections, originalBoostSelections) {
    const { originalBoostType, matchedBoost } = getBoostData(percentageLadder, boostSelections, originalBoostSelections);
    if (originalBoostType) {
        const originalBoostPicks = mapLadderPercentageTypeToPicksInfo[originalBoostType.type];
        if (!matchedBoost) {
            return {
                description: dictionary.myBetsDictionary.BoostDetailsDescriptionNotApplied,
                isBoostDowngraded: true,
            };
        }
        else if (matchedBoost.percentage !== originalBoostType.percentage && originalBoostPicks !== boostSelections) {
            return {
                description: dictionary.myBetsDictionary.BoostDetailsDescriptionDowngrade.replace("{0}", originalBoostPicks.toString()).replace("{1}", boostSelections.toString()),
                isBoostDowngraded: true,
            };
        }
    }
    return {
        description: dictionary.myBetsDictionary.BoostDetailsDescription,
        isBoostDowngraded: false,
    };
}
//# sourceMappingURL=mapBoostHeaderInfo.js.map